import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container container-small" }
const _hoisted_2 = { class: "banner-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sub" }, "Wunschkennzeichen jetzt reservieren und bestellen!", -1)

import { PropType, onMounted, ref } from 'vue';
import LocationAnimation from '@/assets/animations/home-animation-3.json';
import { ILicenseOffice } from '@/classes/interfaces/data';


export default /*#__PURE__*/_defineComponent({
  props: {
  Office: { type: Object as PropType<ILicenseOffice>, required: true },
},
  setup(__props) {

const Props = __props



const BannerStyle = ref<any>({});

onMounted(() => {
  if (Props.Office.HeaderImage != null) {
    BannerStyle.value.backgroundImage = `url(${process.env.VUE_APP_DOMAIN_API}${Props.Office.HeaderImage.url})`;

    console.log(`url(${process.env.VUE_APP_DOMAIN_API}${Props.Office.HeaderImage.url})`);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock("section", {
    class: "location-banner",
    style: _normalizeStyle(BannerStyle.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Vue3Lottie, {
          animationData: _unref(LocationAnimation),
          height: 120,
          width: 200
        }, null, 8, ["animationData"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "Zulassungsstelle " + _toDisplayString(__props.Office.Name), 1),
          _hoisted_4
        ])
      ])
    ])
  ], 4))
}
}

})